import { aggregationTypes, dateColumns, usageEvents, views } from '../../constants/event';

export const getDefaultGroupColumn = (event) => {
  switch (event) {
    case usageEvents.WAU:
      return dateColumns.WEEK;

    case usageEvents.MAU:
      return dateColumns.MONTH;

    default:
      return dateColumns.DAY;
  }
};

export const isEventSpecificField = (field = '') =>
  field.includes('event.') && !field.includes('event._') && !field.includes('event.user_id');

export const dateFields = ['HOUR', 'DAY', 'WEEK', 'MONTH', 'QUARTER'];

export const getChartViews = ({ info }) =>
  dateFields.includes(info.groupBy)
    ? [views.CHART, views.TABLE]
    : [views.COLUMN_CHART, views.TABLE, views.PIE_CHART];

export const getViews = (result) => getChartViews(result[0]);

export const getView = (currentView, result) => {
  const eventViews = getViews(result);

  return eventViews.includes(currentView) ? currentView : eventViews[0];
};

// проверяет валидность ивента из compose: ивент должен содержать имя, а так же при наличии агрегации по полям
// должны быть выбраны поля
export const isValidEvent = ({ aggregationType, aggregationColumn, name }) => {
  const aggregationField = [
    aggregationTypes.SUM,
    aggregationTypes.AVG_TOTAL,
    aggregationTypes.AVG_TOTAL_SPLIT,
  ].includes(aggregationType)
    ? aggregationColumn
    : true;
  return name && aggregationField;
};

// проверяется валидность выполнения запроса на вкладке users. Колонки должны иметь значения либо отсутсвовать полностью,
// а ивент должен быть выбран в любом случае.
export const isValidUsers = (event, columns) => {
  const columnsIsNotEmpty = !!columns.length && columns.every((column) => !!column.value);
  const columnsValid = columns.length === 0 || columnsIsNotEmpty;
  return !!event && columnsValid;
};

export const combineEventsWithSameUniqueChar = (result) =>
  result.reduce((combinedEvents, event) => {
    const eventIndexWithSameUniqueChar = combinedEvents.findIndex((eventsData) =>
      eventsData.some((eventVar) => event.info.uniqueChar[0] === eventVar.info.uniqueChar[0])
    );
    if (eventIndexWithSameUniqueChar !== -1) {
      combinedEvents[eventIndexWithSameUniqueChar].push(event);
      return combinedEvents;
    }
    combinedEvents.push([event]);
    return combinedEvents;
  }, []);

// ивенты без дополнительных периодов в качестве unique char имеют букву алфавита
// при добавлении цифры период является дополнительным.
export const isAdditionalPeriods = (result) =>
  result.length > 1 &&
  result.some(({ info }) => info.uniqueChar.length > 1 && !info.uniqueChar.includes('Others'));

// проверяется наличие  ивентов
export const checkEvents = (events, userEvents) =>
  (events || []).every((e) => (userEvents || []).includes(e));
